module.exports = __webpack_public_path__ + "img/attestation_geek_wait.995f86b1.png";